<template>
	<section
		class="form__section"
		v-show="value.children && value.children.length"
	>
		<header
			class="form__section-header"
			v-if="value.sectionName || value.remark"
		>
			<h3>{{ value.sectionName }}</h3>
			<p>{{ value.remark }}</p>
		</header>
		<div class="form__section-body">
			<div
				:class="['section-component__row-container',{'compact-row':!isNormalStyle},{'ry-form__item-miss-value' : item.checkMissValue && item.isShowTipsText}]"
				v-for="item in value.children"
				:style="{background: (item.checkMissValue && item.isShowTipsText) || item.errorText.length ? 'rgb(254, 244, 217, 1)' : item.displayInfo.showCustom ? item.displayInfo.color : '#ffffff'}"
				v-if="!(item.permission === PERMISSION__HIDDEN || item.hidden === 1 || item.followHidden || !item.displayInfo.show)"
			>
				<component
					:key="item.dataId"
					:is="`control_${item.type}`"
					:type="type"
					:value="item"
				>
				</component>
				<!--必填提示文字-->
				<div
					v-if="item.checkMissValue && item.isShowTipsText && !item.displayInfo.showCustom"
					class="field-tips-text"
				>
					{{item.tipsText}}
				</div>
				<!--自定义样式提示文字-->
				<div
					v-if="item.displayInfo.showCustom && !(item.checkMissValue && item.isShowTipsText)"
					:style="{color: item.displayInfo.color === '#ffffff' ? '#909399' : '#ffffff'}"
					class="field-tips-text"
				>
					{{item.displayInfo.alertMsg}}
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import control from '../control'
	import {
		FORM_STATUS__FILL,
		PERMISSION__HIDDEN,
		FORM_THEME_TYPE_COLOR
	} from '../types'

	export default {
		props: {
			value: Object,
			index: Number,
			type: {
				type: Number,
				default: FORM_STATUS__FILL
			},
			hasHeader: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				formSet: this.value.root,
				PERMISSION__HIDDEN
			}
		},
		components: {
			...control
		},
		computed:{
			isNormalStyle() {
			  return this.formSet.customFormStyle.mobileLayout === 'NORMAL'
			}
		}
	}
</script>


<style lang="less">
	.form__section {

		>header.form__section-header {
			padding: 5px 15px;
			background-color: #F5F5F5;

			>h3 {
				font-size: 17px;
				line-height: 24px;
				font-weight: 500;
				color: #000;
			}

			>p {
				font-size: 12px;
				line-height: 18px;
				color: #969799;
				margin-top: 3px;
			}
		}

		.form__section-body {
			
			border-radius: 10px;
			margin: 10px;
			overflow: hidden;
			.van-cell {
				background-color: transparent;
				line-height: 2;

				&:after {
					border-bottom: none !important;
				}
				
				.van-cell__title{
					color: #000;
					font-size: 15px;
				}
			}

			.van-cell__label {

				.van-field {
					background-color: #ffffff;
				}
			}

			.section-component__row-container.compact-row {
				position: relative;

				&:after {
					position: absolute;
					box-sizing: border-box;
					content: ' ';
					pointer-events: none;
					right: 16px;
					bottom: 0;
					left: 16px;
					border-bottom: 1px solid #ebedf0;
					transform: scaleY(0.5);
				}
			}

			.ry-form__item-miss-value {
				background: rgb(254, 244, 217, 1);
			}

			.field-tips-text {
				margin: -5px 0 0 16px;
				padding-bottom: 10px;
				font-size: 12px;
				color: #f55d54;
			}
		}
	}
</style>
